<template>
  <div class="BatchEdit">
    <a-row type="flex" align="middle" style="margin-bottom:10px">
      <a-col :span="4">
        <span>Modification method</span>
      </a-col>
      <a-col :span="8">
        <a-radio-group v-model="editType" name="radioGroup">
          <a-radio :value="1">
            Item by item
          </a-radio>
          <a-radio :value="2">
            Unified
          </a-radio>
        </a-radio-group>
      </a-col>
    </a-row>
    <a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" labelAlign="left">
      <a-form-item label="Label" v-if="editType === 2">
        <div class="in-wrap">
          <template v-for="(it, i) in tagsList">
            <a :key="i" v-if="it">
              {{ it }}
              <b class="icon-operation_close" @click="deleteTab(2, i)">x</b>
            </a>
          </template>
          <a-input
            allowClear
            style="width: 160px;"
            v-model="tagsStr"
            placeholder="Enter 'enter' to complete the addition"
            @pressEnter="
              () => {
                tabFn()
              }
            "
          ></a-input>
        </div>
        <div>
          <a-select
            v-model="tagsModel"
            @change="
              () => {
                tagsModelFn(2)
              }
            "
            placeholder="Please select an existing label"
          >
            <a-select-option value=""><span style="color: #999">Please select an existing label</span></a-select-option>
            <a-select-option :value="value.tags" v-for="(value, index) in allTags" :key="index">{{
              value.tags
            }}</a-select-option>
          </a-select>
        </div>
      </a-form-item>
      <div v-if="editType === 1">
        <a-form-item v-for="(item, index) in fileList" :key="index">
          <span slot="label">
            <a-popover placement="right" trigger="hover">
              <template slot="content">
                <img :src="item.img" width="240" height="240" />
              </template>
              <img :src="item.img" width="50" height="50" />
            </a-popover>
            <span>Label</span>
          </span>
          <div class="in-wrap">
            <template v-for="(it, i) in item.tags">
              <a :key="i" v-if="it">
                {{ it }}
                <b class="icon-operation_close" @click="deleteTab(1, i, item)">x</b>
              </a>
            </template>
            <a-input
              allowClear
              style="width: 160px;"
              v-model="item.tagValue"
              placeholder="Enter 'enter' to complete the addition"
              @pressEnter="
                () => {
                  tabFn(1, item)
                }
              "
            ></a-input>
          </div>
          <div>
            <a-select
              v-model="item.tagsModel"
              @change="
                () => {
                  tagsModelFn(1, item)
                }
              "
              placeholder="Select an existing label"
            >
              <a-select-option value=""><span style="color: #999">Select an existing label</span></a-select-option>
              <a-select-option :value="value.tags" v-for="(value, index) in allTags" :key="index">{{
                value.tags
              }}</a-select-option>
            </a-select>
          </div>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import { languageData } from '@/utils/const'
import { mapState } from 'vuex'
export default {
  name: 'TagsBatch',
  data() {
    return {
      editType: 1,
      language: 1,
      languageData: languageData,
      tagsList: [],
      tagsStr: '',
      tagsModel: '',
      batchName: {},
      sameName: {},
      form: this.$form.createForm(this, { name: 'TagsBatch' }),
      fileList: []
    }
  },
  computed: {
    ...mapState({
      allTags: state => state.myGallery.allTags
    })
  },
  methods: {
    tagsModelFn(n, item) {
      if (n === 1) {
        if (!item.tagsModel) {
          return
        }
        item.tags.push(item.tagsModel)
        // this.tagIndex++
      } else {
        if (!this.tagsModel) {
          return
        }
        this.tagsList.push(this.tagsModel)
        this.tagsModel = ''
      }
    },
    tabFn(n, item) {
      if (n === 1) {
        if (!item.tagValue) {
          return
        }
        item.tags.push(item.tagValue)
        item.tagValue = ''
      } else {
        // 统一
        if (!this.tagsStr) {
          return
        }
        this.tagsList.push(this.tagsStr)
        this.tagsStr = ''
      }
    },
    deleteTab(n, i, item) {
      if (n === 1) {
        item.tags.splice(i, 1)
      } else {
        this.tagsList.splice(i, 1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.brands,
.risks {
  width: 50%;
  > .title {
    line-height: 16px;
    margin: 0;
  }
  .brand,
  .risk {
    img {
      margin-right: 10px;
    }
    span {
      margin-right: 10px;
    }
  }
}
.in-wrap {
  border: 1px solid #ccc;
  padding: 8px;
  color: #555;
  // border-radius: 4px;
  line-height: 1.4;
  a {
    padding: 3px 5px;
    background-color: #d4eaff;
    border-radius: 3px;
    cursor: pointer;
    display: inline-block;
    color: #428bca;
    text-decoration: none;
    margin: 1px 0;
    margin-right: 5px;
    .icon-operation_close {
      font-weight: normal;
      font-size: 14px;
      color: #333;
    }
  }
}
</style>
